import classNames from 'classnames';
import { createElement } from 'react';
import * as styles from './Typography.module.scss';

type Props = {
  className?: string;
  color?: 'error' | 'gray' | 'green';
  component?: 'div' | 'span' | 'h1' | 'h2';
  mb?: '8' | '12' | '16' | '24' | '48';
  mt?: '2xl';
  variant?:
    | 'body1'
    | 'body2'
    | 'body3'
    | 'caption'
    | 'headline1'
    | 'headline2'
    | 'subhead2'
    | 'title1'
    | 'title2'
    | 'title3'
    | 'xltitle'
    | 'xxxltitle';
};

// loosely based upon https://mui.com/components/typography/
export default function Typography({ children, className, color, component = 'span', mb, mt, variant }: React.PropsWithChildren<Props>) {
  const variantClassName = variant && styles[variant];
  // because of css-loader exportLocalsConvention camelCase the X is uppercase
  // Maybe we should see what library/logic css-loader uses for camel-casing and clone that here?
  const mbClassName = mb && styles[`mb${mb}`];
  const mtClassName = mt && styles[mt === '2xl' ? 'mt2Xl' : `mt${mt}`];
  const colorClassName = color && styles[color];
  return createElement(component, { className: classNames(variantClassName, mbClassName, mtClassName, colorClassName, className) }, children);
}
